import { ILinkProps } from './types';
import { Link } from './Link';

export const Links: Record<string, React.FC<ILinkProps>> = {
    Link,
}
